import * as z from "zod/v4";

export const MarketplaceNotificationStatusSchema = z.discriminatedUnion(
  "status",
  [
    z.object({ status: z.literal("complete") }),
    z.object({ status: z.literal("skipped") }),
    z.object({ status: z.literal("pending"), date: z.date().nullish() }),
    z.object({ status: z.literal("failed"), actionMessage: z.string() }),
  ],
);

export type MarketplaceNotificationStatus = z.infer<
  typeof MarketplaceNotificationStatusSchema
>;

export interface IMarketplaceNotificationStatus
  extends z.ZodType<MarketplaceNotificationStatus> {}
